export const SavedViewIcon = ({
  className,
  filled,
  ...rest
}: {
  filled?: boolean;
  className?: string;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    className={className}
    {...rest}
  >
    <path
      fill="currentColor"
      d={
        filled
          ? "M15.958 6.157c-.122-.373-.482-.63-.99-.703l-4.142-.602L8.976 1.1C8.747.64 8.392.375 8 .375s-.747.264-.975.725L5.174 4.852l-4.142.602c-.508.074-.869.33-.99.703-.12.373.02.792.388 1.15l2.997 2.921-.708 4.125c-.09.527.064.843.21 1.015.17.203.418.314.7.314.21 0 .435-.062.667-.184L8 13.551l3.704 1.947c.232.122.457.184.668.184.28 0 .53-.111.7-.314.145-.172.3-.488.209-1.015l-.708-4.125 2.997-2.92c.367-.359.509-.778.388-1.151Z"
          : "M15.958 6.157c-.122-.373-.482-.63-.99-.703l-4.142-.602L8.976 1.1C8.747.64 8.392.375 8 .375s-.747.264-.975.725L5.174 4.852l-4.142.602c-.508.074-.869.33-.99.703-.12.373.02.792.388 1.15l2.997 2.921-.708 4.125c-.09.527.064.843.21 1.015.17.203.418.314.7.314.21 0 .435-.062.667-.184L8 13.551l3.704 1.947c.232.122.457.184.668.184.28 0 .53-.111.7-.314.145-.172.3-.488.209-1.015l-.708-4.125 2.997-2.92c.367-.359.509-.778.388-1.151Zm-1.043.48-3.172 3.092a.469.469 0 0 0-.135.415l.749 4.367c.022.127.012.2.004.233a.579.579 0 0 1-.22-.075l-3.923-2.063a.469.469 0 0 0-.436 0L3.86 14.668a.58.58 0 0 1-.22.076.576.576 0 0 1 .003-.233l.75-4.367a.469.469 0 0 0-.135-.415L1.085 6.636a.578.578 0 0 1-.14-.186.577.577 0 0 1 .222-.068l4.386-.638a.469.469 0 0 0 .352-.256l1.961-3.973A.577.577 0 0 1 8 1.324a.577.577 0 0 1 .134.19l1.96 3.974c.07.138.201.234.354.256l4.385.638c.127.018.193.05.222.068a.58.58 0 0 1-.14.186Z"
      }
    />
  </svg>
);
